import { Extension } from "../../graphql/generated";
import { BPBaseResource } from "./base-resource";

export type MinimumExtension = Pick<Extension, "spec" | "metadata">;

export class BPExtension extends BPBaseResource implements Extension {
  __typename?: "Extension" | undefined;

  constructor(d: MinimumExtension) {
    super();

    this.kind = "Extension";
    this.metadata = d.metadata;
    this.spec = d.spec;
  }
}
